module.exports = __webpack_public_path__ + "img/ticket.e2dcc8aa.jpg";